define('helpers/mixins',[
    'evertrue',
    'jquery',
    'underscore',
    'backbone',
    'ET/ETView',
    'views/components/FormView',
    'models/contact/PropertyModel'
], function MixinFactory(EverTrue, $, _, Backbone, ETView, FormView, PropertyModel) {

    // Mixins are common functions or properties that are shared between views/models/collections etc
    // Create Objects with methods or properties to be shared in other views
    // Reference: http://ricostacruz.com/backbone-patterns/#mixins

    // Example Usage:
    // EverTrue.MyView = ETView.extend({
    //     _.extend({}, Mixin.MyMixin, {
    //           // View Contents go here and can reference this.my_mixin_method
    //     });
    // });

    var Mixin = {};

    Mixin.Tables = {
        setSort: function(prop) {
            this.sort = this.sort || {};

            if (this.sort.prop && this.sort.prop == prop) {
                this.sort.reverse = !this.sort.reverse;
            } else {
                this.sort.reverse = false;
            }

            this.sort.prop = prop;
            this.sort.template = this.sort.reverse ? "<i class='icon-sort-down'></i>" : "<i class='icon-sort-up'></i>";
        },

        sortProperties: function(collection, property, reverse, is_number) {
            var props = (property) ? property.split(".") : [],
                prop = _.first(props);

            props.shift();
            if (is_number) {
                collection.comparator = function(a) {
                    return reverse ? -a.get(prop) : a.get(prop);
                };
            } else {
                collection.comparator = function(a, b) {
                    var items = [a.get(prop), b.get(prop)];

                    if (!items[0]) return 1;
                    if (!items[1]) return -1;

                    if (props.length !== 0) {
                        _.each(props, function(value){
                            items[0] = items[0][value];
                            items[1] = items[1][value];
                        });
                    }

                    items[0] = JSON.stringify(items[0]);
                    items[1] = JSON.stringify(items[1]);

                    return reverse ? -items[0].localeCompare(items[1]) : items[0].localeCompare(items[1]);
                };
            }
            collection.sort();
        }
    };

    Mixin.Modal = {
        // Form Modal for creating a new custom property
        // triggers "property:created on completion"
        createCustomProperty: function(callback) {
            var module, self = this;
            module = FormView.extend({
                parentView: self,
                formObj: {
                    modal: 'newCustomPropertyModal',
                    fieldset:[{
                        legend: "Create Custom Field",
                        submit_label: "Save Custom Field",
                        formElements: [{
                            type: "text",
                            label: "Field Label",
                            key: "description",
                            maxlength: 50
                        },{
                            type: "select",
                            label: "Type of Data",
                            key: "data_type",
                            select: [
                                {val: "string", val_display: "Text"},
                                {val: "boolean", val_display: "Yes / No"},
                                {val: "number", val_display: "Number"},
                                {val: "date_string", val_display: "Date"},
                                {val: "currency", val_display: "Money"},
                            ]
                        }]
                    }]
                },
                onFormSubmit: function(formData){
                    var model = new PropertyModel(formData),
                        dialog = self.modals.CustomProperty;

                    model.set({name: model.get("description").toLowerCase().replace(/ /g, "")});

                    dialog.loading(true, dialog.$('.modal-body'));
                    dialog.$el.find(".modal-footer .btn").hide();
                    dialog.$el.find(".modal-footer").append("<span class='text-info'>Please wait while we save your custom field</span>");

                    model.on("saved", function() {
                        self.modals.CustomProperty.$el.modal("hide");
                        self.trigger("property:created", model);
                        if (_.isFunction(callback)) {
                            callback();
                        }
                    });

                    model.on("saved:error", function() {
                        dialog.loading(false, dialog.$('.modal-body'));
                        dialog.$el.find(".modal-footer .btn").show();
                        dialog.$el.find(".text-info").remove();
                    });
                    model.create();
                }
            });
            this.modals = this.modals || [];
            this.modals.CustomProperty = new module({render: false});
            this.modals.CustomProperty.render(function(){
                $("body").append(self.modals.CustomProperty.$el);
                self.modals.CustomProperty.$el.modal("show");
            });
        } // close custom prop

    };

    Mixin.Collection = {
        parse: function(data) {
            this._pagination = _.omit(data, 'items');

            if (data.total <= data.limit) {
                this.boundary = "none";
            } else if (data.offset === 0) {
                this.boundary = "first";
            } else if (data.offset + data.limit >= data.total) {
                this.boundary = "last";
            } else {
                this.boundary = false;
            }

            return data.items;
        },

        setPage: function(page) {
            this.page = this.page;
            this.setOffset();
        },

        changePage: function(change) {
            this.page = this.page + change;
            this.setOffset();
        },

        setOffset: function() {
            var max_page = Math.ceil(this._pagination.total / this.limit);

            if (this.page <= 0) {
                this.page = 0;
            } else if (this.page > max_page) {
                this.page = max_page;
            }

            this.offset = Math.max(this.page - 1, 0) * this.limit;
        }
    };

    return Mixin;
});


